import { render, staticRenderFns } from "./entry-mv.vue?vue&type=template&id=3ab3db90&"
import script from "./entry-mv.vue?vue&type=script&lang=js&"
export * from "./entry-mv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports